import styled, { css } from 'styled-components';
import { Item as IT } from '../styles';

export const Header = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 770px) {
    margin: 0.5rem 0;
  }

  @media (max-width: 770px) {
    display: none;
    height: 0%;
  }
  img {
    max-width: 105px;
  }
`;

export const Items = styled.div`
  @media (max-width: 770px) {
    display: none;
  }
  height: 85vh;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const Item = styled(IT)`
  @media (max-width: 770px) {
    display: none;
  }
  div {
    display: flex;
    margin: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img.job-control {
      width: 40px;
    }

    span {
      margin: auto;
      max-width: 100px;
      font-size: 12px;
      line-height: 15px;
      position: relative;
      z-index: 2;
      ${({ titleStore }) =>
        titleStore === 'Desafio Lapidar' &&
        css`
          margin-top: 0;
        `}
    }
  }

  &:not(:first-child) {
    margin-top: 25px;
  }
  display: flex;
  position: relative;
  height: ${props => (props.height ? props.height : '15%')};
  background-color: ${props => (props.selected ? 'white' : 'transparent')};
  width: ${props => (props.selected ? '90%' : '100%')};
  border-radius: 25px 0px 0px 25px;
  box-shadow: ${props => (props.selected ? '0px 7px 6px -5px #00000066' : '')};
  &:after {
    content: '';
    position: absolute;
    background-color: trasparent;
    right: 0px;
    top: -50px;
    height: 50px;
    width: 25px;
    border-bottom-right-radius: 25px;
    box-shadow: 0 25px 0 0
      ${props => (props.selected ? 'white' : 'transparent')};
  }
  &:before {
    content: '';
    position: absolute;
    background-color: transparent;
    bottom: -50px;
    right: 0px;
    height: 50px;
    width: 20px;
    border-top-right-radius: 25px;
    box-shadow: 0 -25px 0 0 ${props => (props.selected ? 'white' : 'transparent')};
    z-index: 1;
  }
`;
